// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"05e4b238","455":"d6d955bf"}[chunkId] + ".chunk.js";
};